import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  NgZone,
} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { StoreDataServiceService } from './store-data-service.service';
import { ActivatedRoute } from '@angular/router';
import { AngularFireRemoteConfig } from '@angular/fire/compat/remote-config';
import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';
import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/service/util.service';
import {
  RemoteConfig,
  fetchAndActivate,
  getValue,
} from 'firebase/remote-config';
import { ConstantService } from './service/constant.service';
import { EncryptionService } from './service/encryption.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { SettingsService } from './settings.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,

    //navText: ['&#8249', '&#8250;'],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      760: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
    nav: false,
  };
  IpAddress = '';
  themes: string = '';
  returnUrl: string = '';
  isChecked: boolean = true;
  title = '5P_Insta_Rewards';
  showLoader = false;
  patterns = [
    '/SignOn/Auth',
    // '/Home/ClientCookieAuth',
    '/vlogin-page',
    '/login-customersupport',
    '/error',
    '/lwp',
    '/dealer',
  ];
  myCurrentURL: string = '';
  patternRedirectionURL: string = '';
  domainUrl: string;
  hostOrigin: string;
  pathname: string;
  queryParams: string;

  //public IpAddress : any;
  constructor(
    private storeDataServiceService: StoreDataServiceService,
    private renderer: Renderer2,
    private el: ElementRef,
    private activatedRouter: ActivatedRoute,
    private remoteConfig: AngularFireRemoteConfig,
    public constantService: ConstantService,
    private utilService: UtilService,
    private encryptionService: EncryptionService,
    private zone: NgZone,
    private toastr: ToastrService,
    private cookieService: CookieService
  ) {
    this.determineTheme();
  }

  applyTheme(theme: string) {
    if (theme === 'dark') {
      this.renderer.addClass(document.body, 'dark-mode');
    } else {
      this.renderer.removeClass(document.body, 'dark-mode');
    }
  }
  // determines the theme
  determineTheme() {
    if (this.cookieService.check('theme')) {
      this.themes = this.cookieService.get('theme');
    } else {
      let storedTheme = this.storeDataServiceService.getUser_Themes();
      if (storedTheme !== undefined) {
        this.themes = storedTheme;
      } else {
        this.themes = this.detectSystemTheme(); // Default to system theme
      }
    }
    this.isChecked = this.themes === 'dark';
    this.storeDataServiceService.setUser_Themes(this.themes);
    this.applyTheme(this.themes); // Apply the theme without toggling
  }

  toggleDarkMode() {
    this.themes = this.themes === 'dark' ? 'light' : 'dark'; // Toggle the theme
    this.storeDataServiceService.setUser_Themes(this.themes);
    this.applyTheme(this.themes); // Apply the updated theme
    this.isChecked = this.themes === 'dark';
  }
  // detects the system theme if no theme is set
  detectSystemTheme(): string {
    try {
      let value = window.matchMedia?.('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
      return value;
    } catch (e) {
      return 'light';
    }
  }

  async ngOnInit(): Promise<void> {
    try {
      const settings = {
        authBaseAPI: 'https://gateway.5paisa.com/AuthApi/',
        pwaSpotbaseAPI: 'https://gateway.5paisa.com/pwaspot/',
        boApi: 'https://gateway.5paisa.com/BoAPI/Common/',
        ocpApimSubscriptionKeyBoApi: 'e5a8b69d9994693a07a538cac4c7c1a3b0591bb9',
        ocpApimSubscriptionKey: 'e5a8b69d9994693a07a538cac4c7c1a3b0591bb9',
        ocpApimSubKey: '8eeee59bdab88bace6189d001f96487e',
        apiHeadKey: '4dddd59bdab77bace6189d001f96487e',
        userId: 'ZyT47UW2g56',
        password: 'H98qlU4Sn2',
        authorization: 'Basic NXBhaXNhVWF0OjVwYWlzYUB3ZWJVYXQ=',
        pwaAllowUsers: '100',
        keyValue: '842a357c4b385726090aa184b75b691075da95e6ddd4eb40',
        ivValue: '53471a3a3623160b53471a3a3623160b',
        accountPending:
          'https://eaccount.5paisa.com/ClientLogin/VerifyClientLoginMobile',
        pwaUrl: 'https://pwaweb.5paisa.com/#/activation',
        cookieExpireTime: '30',
        tradestationUrl: 'https://web.5paisa.com/',
        noOfDeviceBinded: '4',
        logApiUrl: 'https://uatapi.5paisa.in/brokingcommonapi/api/login/v1/',
        privateChecksumkey:
          'MDwwDQYJKoZIhvcNAQEBBQADKwAwKAIhAJ5Cj2yA/StpN7Bf1XayJ84Ta1aYR2V/0GmMI10wDhtlAgMBAAE=',
        boApiHeadParamKey: 'kahdAjhfdsd423jkoi3frDFD3vbxvzyXZ4S4dF',
        showFnoPopUp: 'true',
        activationModificationUrl: 'https://diygateway.5paisa.com/5peaccount/',
        activationUrl: 'https://gateway.5paisa.com/5peaccount/',
        tokenUserName:
          '3pH1UiSyjsnh8hVq9PuRdFvzIhMz+3dsBagjmJpP8XkkoX5+f/5unYYmamsjZAmi',
        tokenPassword: '4AYM8OOag1zEHsDbz5bLAjUekzVYwpywlLotOEBffag=',
        activationOcpkey: 'a8ed3b7ead504fa8903d9c7e0d23bc61',
        activationMerchentkey: '3s@nY!mNgOH9p0Td',
        OcpkeyNominee: '61d16cfb2ce24ae69e66c4911ec4fc9e',
        OptoutUrl:
          'https://emodify.5paisa.com/customer-dashboard/client-profile?source=nominee_declaration&appsource=App&nomtype=opt_in',
        voucherAuthorizationkey:
          'K1l2Z1luRWo0S3MvQXhWVENHb0VweDdpeTNvNlJldHc5WnV3b0xseWZZZz06K1l2Z1luRWo0S3MvQXhWVENHb0VweUlpQUdnWjRkSGt3a3VHL3ZqRHlpWVB5Y0xRdHc4V211cnNrVUhRSkxULw==',
        authApiChecksumPrivateKey:
          'MDwwDQYJKoZIhvcNAQEBBQADKwAwKAIhAINkrQAw+cxsWexQ2g8Wn1oHQvPsA8dve8bLNbHuXTanAgMBAAE=',
        termsAndConditionUrl: 'https://www.5paisa.com/terms-and-conditions',
        fnoUrl: 'https://fno.5paisa.com/',
        algoSpaceUrl:
          'https://dev-openapi.5paisa.com/WebVendorLogin/VLogin/Index?VendorKey=vb04eIPKtTKE631vVxZ5l2npG4xzJbFY&ResponseURL=https%3A%2F%2Falgospace.5paisa.com%2Fapp-api%2Faccounts%2Fapi%2Fv1%2Fauth%2Fo-auth%2Ff5paisa%2Fcallback',
        tradeApiUrl: 'https://gateway.5paisa.com/tradeapi/',
        encrptionTokenForMobileNumber:
          '576E5A7234753778217A25432A462D4A614E645267556B58703273357638792F',
        chartUrl: 'https://tv.5paisa.com',
        cookieDomainAuthkey: 'CC4AF799EE1DEC6E648F6C2B4DDB1',
        pwauatCookieApiUrl: 'https://pwauatapi.5paisa.com/',
        pwaNewUrl: 'https://kyc.5paisa.com/activation-new',
        modificationUrl: 'https://diygateway.5paisa.com/emodify/',
        modificationOcpkey: '61d16cfb2ce24ae69e66c4911ec4fc9e',
        tradestationNewUrl: 'https://newweb.5paisa.com/',
        kycApiUrl: 'https://kycapi.5paisa.com/auth/',
        swarajauthProdUrl:
          'https://swarajauth.5paisa.com/AuthenticateService/Service1.svc/',
        swarajuserId: 'RaM08AN5d13',
        swarajpassword: 'R08ama1NT3',
        FivePeaccontOcpkey: 'a005f813e8a44ff9b8b45c61583b3820',
        getContentApiUrl:
          'https://swarajauth.5paisa.com/AuthenticateService/Service1.svc/GetContent',
      };

      const settingsWithEncryptedVals = Object.keys(settings).reduce(
        (acc, key) => {
          const value = settings[key];
          const encryptedValue =
            this.encryptionService.encryptUsingAES_256(value);

          acc[key] = encryptedValue;
          return acc;
        },
        {}
      );

      const stringifiedSettings = JSON.stringify(settingsWithEncryptedVals);
      const encryptedSettings =
        this.encryptionService.encryptUsingAES_256(stringifiedSettings);

      console.log('ENCRYPTED SETTINGS', { data: encryptedSettings });

      const decodedSettingsStr =
        this.encryptionService.decryptUsingAES_256(encryptedSettings);
      const decryptedSettingsWithEncryptedVals = JSON.parse(decodedSettingsStr);

      const decryptedSettings = Object.keys(
        decryptedSettingsWithEncryptedVals
      ).reduce((acc, key) => {
        const encryptedValue = decryptedSettingsWithEncryptedVals[key];
        const value =
          this.encryptionService.decryptUsingAES_256(encryptedValue);

        acc[key] = value;
        return acc;
      }, {});

      console.log('DECRYPTED SETTINGS', decryptedSettings);
    } catch (e) {
      console.error(e);
    }
    this.showLoader = true;
    this.initializeFireBaseAppAndRemoteConfig()
      .then(() => {})
      .finally(() => {});
    this.storeDataServiceService
      .fetchData()
      .then((result) => {
        this.IpAddress = result;
        this.storeDataServiceService.setIpAddress(this.IpAddress);
      })
      .finally(() => {
        this.showLoader = false;
      })
      .catch((error) => {
        this.showLoader = false;
        console.log('error', error);
      });
  }

  // toggles the theme of login page

  isChangedtheme(): void {
    this.storeDataServiceService.defafulThemeChange('Y');
    this.toggleDarkMode();
  }
  initializeFireBaseAppAndRemoteConfig = async () => {
    try {
      const app = initializeApp(environment.firebase);
      const remoteConfig: RemoteConfig = getRemoteConfig(app);
      remoteConfig.settings.minimumFetchIntervalMillis = 60000;

      await fetchAndActivate(remoteConfig);
      const frontend_crossSell_keys = getValue(
        remoteConfig,
        'frontend_crossSell_keys'
      ).asString();
      const web_tradestation_url = getValue(
        remoteConfig,
        'web_tradestation_url'
      ).asString();
      let remoteConfigData, webremoteConfigData;
      try {
        remoteConfigData = JSON.parse(frontend_crossSell_keys);
        webremoteConfigData = JSON.parse(web_tradestation_url);
        this.storeDataServiceService.setFirebasePopupConfigration(
          remoteConfigData.isPopupEnabled
        ); // this value in global service
        this.storeDataServiceService.setDelayApiResponseTimer(
          remoteConfigData.APIDelayValue
        ); // this value in global service
        this.storeDataServiceService.setApiTimeoutFirebaseConfigration(
          remoteConfigData.APITimeoutValue
        );
        this.myCurrentURL = remoteConfigData.myCurrentURL.toLowerCase();
        this.patternRedirectionURL =
          remoteConfigData.patternRedirectionURL.toLowerCase();
        this.storeDataServiceService.setCaptchaEnabled(
          remoteConfigData.isCaptchaEnabled
        ); //isCaptchaEnabledPreProd
        this.storeDataServiceService.setNeedtoCallTradestationBetaApi(
          remoteConfigData.tradestationRedirectionThroughAPI
        ); // 'Y'
        this.storeDataServiceService.setTradestationRedirectionValue(
          remoteConfigData.tradestationRedirectionValue
        ); // 'OT & NT'
        this.storeDataServiceService.setdefaultTradestationUrl(
          webremoteConfigData.url
        );
        this.storeDataServiceService.setdefaultNewTradestationUrl(
          webremoteConfigData.newUrl
        );
        this.storeDataServiceService.setSwarajauthSecretKey(
          remoteConfigData.swarajauthProductionSecretKey
        );
        this.storeDataServiceService.setAllowDomainList(
          remoteConfigData.allowDormantUserForDomain
        );
        this.storeDataServiceService.setAspxAuthAPI(
          remoteConfigData.isToCallAspxauthAPI
        );
      } catch (error) {
        console.error('Error parsing remote config data', error);
        this.setDefaultConfig();
      }
    } catch (err) {
      console.error('Error initializing Firebase', err);
      this.setDefaultConfig();
    } finally {
    }
  };

  setDefaultConfig() {
    this.storeDataServiceService.setFirebasePopupConfigration(true); // if error then set default value true
    this.myCurrentURL = 'https://login.5paisa.com';
    this.patternRedirectionURL = 'https://login.5paisa.com';
    this.storeDataServiceService.setCaptchaEnabled('N'); // if error then set default value false
  }

  showSuccess() {
    this.toastr.error('Hello world!', 'Toastr fun!', {
      timeOut: 3000,
      closeButton: true,
      progressBar: true,
    });
  }
}
